import React from 'react';
import './FieldCard.scss';
import { FormField } from '../types';
import { ActionMenu } from '@/components/Elements/ActionMenu';
import { ReactComponent as SelectedIcon } from '@/assets/img/selected-tick.svg';
import { ReactComponent as DelselectedIcon } from '@/assets/img/deselected-tick.svg';

type FieldCardProps = {
  data: FormField;
  isSelected: boolean;
  options?: any;
  onSelect: (data: FormField) => void;
  showType?: boolean;
};

const FieldCard = ({ data, isSelected, options, onSelect, showType = true }: FieldCardProps) => {
  return (
    <div className={`field-card ${isSelected ? 'selected' : ''}`} onClick={() => onSelect(data)}>
      <div className="left-section-field">
        {isSelected ? <SelectedIcon /> : <DelselectedIcon />}
        <div className="field-card-content">
          <div className="name">{data.fieldLabel}</div>
          {showType && <div className="description">{data.fieldType}</div>}
        </div>
      </div>
      {options && <ActionMenu options={options} />}
    </div>
  );
};

export default FieldCard;
